export enum Pages {
  Home = 'home',
  EndUserVerification = 'endUserVerification',
  ClientPortalChats = 'clientPortalChats',
  SecureDataSharing = 'secureDataSharing',
  ApprovalRequest = 'approvalRequest',
  TechnicianVerification = 'technicianVerification',
  SMSMessaging = 'smsMessaging',
  WhatsAppMessaging = 'whatsAppMessaging',
  QuickTicket = 'quickTicket',
  MSTeamsChats = 'MSTeamsChats',
  CallScribe = 'callScribe',
  ScheduleAssist = 'scheduleAssist',
  Chats = 'chats',
  Alpha = 'alpha',
}

export enum VerificationPages {
  VerificationItem = 'verificationItem',
  VerificationData = 'verificationData',
}

export enum ActionsPages {
  SelectActions = 'SelectActions',
  CreateSecureData = 'CreateSecureData',
  SendSecureData = 'SendSecureData',
}
